import { isWeb, SelectionGroup, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { type OnDone, tagged } from "../../lib/flow-engine";
import { sentryService } from "../../lib/sentry";
import { type Intent, isIntent } from "./types";
export type IntentForkOutcomes = {
  selected: {
    intent: Intent;
  };
  back: {};
};
const Outcome = tagged<IntentForkOutcomes>();
const INTENT_OPTIONS: ReadonlyArray<{
  intent: Intent;
  label: string;
  src: {
    web: string;
    native: string;
  };
}> = [{
  intent: "bill",
  label: "Analyze my medical bill",
  src: {
    web: "/static/onboarding/intent-bill.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-bill.png")
  }
}, {
  intent: "learn",
  label: "Understand my benefits",
  src: {
    web: "/static/onboarding/intent-learn.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-learn.png")
  }
}, {
  intent: "other",
  label: "Something else",
  src: {
    web: "/static/onboarding/intent-other.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-other.png")
  }
}];
export function IntentFork({
  onDone
}: {
  onDone: OnDone<IntentForkOutcomes>;
}) {
  return <OnboardingScreen data-sentry-element="OnboardingScreen" data-sentry-component="IntentFork" data-sentry-source-file="IntentFork.tsx">
      <OnboardingScreen.Nav onBackPress={() => onDone(Outcome.back())} showLogo={false} data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="IntentFork.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="IntentFork.tsx">
        <OnboardingScreen.Header alignment="left" title="How can we help?" subtitle="Let us know what's on your mind — we'll guide you step by step from there." showLogo={false} data-sentry-element="OnboardingScreen.Header" data-sentry-source-file="IntentFork.tsx" />
        <YStack gap="$sp1.5" data-sentry-element="YStack" data-sentry-source-file="IntentFork.tsx">
          <SelectionGroup mode="radio" value="" onChange={value => {
          // Values come from the typed `INTENT_OPTIONS` array, so a non-Intent
          // value should never reach here.
          // TODO Fix SelectionGroup to allow generic-typed data: https://linear.app/medbillai/issue/GRO-686/add-generic-data-support-to-selectiongroup-component
          if (!isIntent(value)) {
            sentryService.captureException(new Error(`IntentFork received unexpected SelectionGroup value: ${String(value)}`));
            onDone(Outcome.selected({
              intent: "other"
            }));
            return;
          }
          onDone(Outcome.selected({
            intent: value
          }));
        }} data-sentry-element="SelectionGroup" data-sentry-source-file="IntentFork.tsx">
            {INTENT_OPTIONS.map(({
            intent,
            label,
            src
          }) => <SelectionGroup.Row key={intent} testID={`intent-fork.${intent}`} value={intent} label={label} leading={{
            type: "image",
            source: isWeb ? src.web : src.native
          }} />)}
          </SelectionGroup>
        </YStack>
      </OnboardingScreen.Content>
    </OnboardingScreen>;
}